<template>
  <div class="booking-add-ons-form__airport-transfer-service">
    <form
      class="form"
      @input="validateForm"
    >
      <fieldset>
        <legend>{{ addOn.vehicleTypeLabel }}:</legend>
        <div class="flex-grid-1-col gutter-lg">
          <div v-if="vehicleOptions.length > 1" class="input dropdown mb-0">
            <select
              id="vehicleType"
              v-model="vehicleType"
              :class="[{ 'have-value': !!vehicleType }]"
              name="vehicleType"
              data-val="true"
              data-field-type="DropdownList"
            >
              <option
                v-for="(vehicleOpt) in vehicleOptions"
                :key="`vehicleOption-${vehicleOpt.key}`"
                :value="vehicleOpt.key"
              >
                {{ getVehicleOptWithPrice(vehicleOpt) }}
              </option>
            </select>

            <label
              for="vehicleType"
              class=" floating"
            >
              {{ addOn.vehicleTypeLabel }}
            </label>

            <span
              data-valmsg-for="vehicleType"
              data-valmsg-replace="true"
              class="field-validation-valid"
            />
          </div>
          <div v-else class="input">
            {{ getVehicleOptWithPrice(vehicleOptions[0]) }}
          </div>
        </div>
      </fieldset>
      <fieldset v-if="showArrivalSection">
        <legend>{{ addOn.arrivalInformationLabel }}:</legend>
        <div class="flex-grid-1-col gutter-lg">
          <div class="input dropdown">
            <select
              id="arrivalType"
              v-model="arrivalType"
              :class="[{ 'have-value': !!arrivalType }]"
              name="arrivalType"
              data-val="true"
              data-field-type="DropdownList"
            >
              <option
                v-for="(arrivalOpt, arrivalIndex) in arrivalOptions"
                :key="`arrivalOpt-${arrivalIndex}`"
                :value="arrivalOpt"
              >
                {{ arrivalOpt }}
              </option>
            </select>

            <label
              for="arrivalType"
              class="req floating"
            >
              {{ addOn.arrivalTypeLabel }}
            </label>

            <span
              data-valmsg-for="arrivalType"
              data-valmsg-replace="true"
              class="field-validation-valid"
            />
          </div>
        </div>
        <div class="flex-grid-2-col gutter-lg">
          <div class="input">
            <input
              id="arrivalFlightNumber"
              v-model="arrivalFlightNumber"
              :class="[{ 'have-value': !!arrivalFlightNumber }]"
              type="text"
              name="arrivalFlightNumber"
              data-val="true"
              data-field-type="SingleLineText"
            >

            <label
              for="arrivalFlightNumber"
              class="req floating"
            >
              {{ addOn.arrivalFlightNumberLabel }}
            </label>

            <span
              data-valmsg-for="arrivalFlightNumber"
              data-valmsg-replace="true"
              class="field-validation-valid"
            />
          </div>
          <div class="input">
            <input
              id="arrivalAirport"
              v-model="arrivalAirport"
              :class="[{ 'have-value': !!arrivalAirport }]"
              type="text"
              name="arrivalAirport"
              data-val="true"
              data-field-type="SingleLineText"
            >

            <label
              for="arrivalAirport"
              class="req floating"
            >
              {{ addOn.arrivalAirportLabel }}
            </label>

            <span
              data-valmsg-for="arrivalAirport"
              data-valmsg-replace="true"
              class="field-validation-valid"
            />
          </div>
        </div>
        <div class="flex-grid-2-col gutter-lg">
          <div class="input dropdown">
            <select
              id="arrivalDate"
              v-model="arrivalDate"
              :class="[{ 'have-value': !!arrivalDate }]"
              name="arrivalDate"
              data-val="true"
              data-field-type="DropdownList"
            >
              <option
                v-for="(date) in datesAvailable"
                :key="`date-${date.value}`"
                :value="date.value"
              >
                {{ date.label }}
              </option>
            </select>

            <label
              for="arrivalDate"
              class="req floating"
            >
              {{ addOn.arrivalDateLabel }}
            </label>

            <span
              data-valmsg-for="arrivalDate"
              data-valmsg-replace="true"
              class="field-validation-valid"
            />
          </div>
          <div class="input">
            <input
              id="estimatedArrivalTime"
              v-model="estimatedArrivalTime"
              :class="[{ 'have-value': !!estimatedArrivalTime }]"
              type="text"
              name="estimatedArrivalTime"
              data-val="true"
              data-field-type="SingleLineText"
            >

            <label
              for="estimatedArrivalTime"
              class="req floating"
            >
              {{ addOn.estimatedTimeOfArrivalLabel }}
            </label>

            <span
              data-valmsg-for="estimatedArrivalTime"
              data-valmsg-replace="true"
              class="field-validation-valid"
            />
          </div>
        </div>
        <div class="flex-grid-1-col gutter-lg">
          <div class="input">
            <textarea
              id="arrivalNotes"
              v-model="arrivalNotes"
              :class="[{ 'have-value': !!arrivalNotes }]"
              name="arrivalNotes"
              data-val="true"
              rows="3"
              data-field-type="MultipleLineText"
            />

            <label
              for="arrivalNotes"
              class="floating"
            >
              {{ addOn.arrivalNotesLabel }}
            </label>

            <span
              data-valmsg-for="arrivalNotes"
              data-valmsg-replace="true"
              class="field-validation-valid"
            />
          </div>
        </div>
      </fieldset>
      <fieldset v-if="showDepartureSection">
        <legend>{{ addOn.departureInformationLabel }}:</legend>
        <div class="flex-grid-1-col gutter-lg">
          <div class="input dropdown">
            <select
              id="departureType"
              v-model="departureType"
              :class="[{ 'have-value': !!departureType }]"
              name="departureType"
              data-val="true"
              data-field-type="DropdownList"
            >
              <option
                v-for="(departureOpt, departureIndex) in departureOptions"
                :key="`departureOpt-${departureIndex}`"
                :value="departureOpt"
              >
                {{ departureOpt }}
              </option>
            </select>

            <label
              for="departureType"
              class="req floating"
            >
              {{ addOn.departureTypeLabel }}
            </label>

            <span
              data-valmsg-for="departureType"
              data-valmsg-replace="true"
              class="field-validation-valid"
            />
          </div>
        </div>
        <div class="flex-grid-2-col gutter-lg">
          <div class="input">
            <input
              id="departureAirport"
              v-model="departureAirport"
              :class="[{ 'have-value': !!departureAirport }]"
              type="text"
              name="departureAirport"
              data-val="true"
              data-field-type="SingleLineText"
            >

            <label
              for="departureAirport"
              class="req floating"
            >
              {{ addOn.departureAirportLabel }}
            </label>

            <span
              data-valmsg-for="departureAirport"
              data-valmsg-replace="true"
              class="field-validation-valid"
            />
          </div>
          <div class="input">
            <input
              id="departureFlightNumber"
              v-model="departureFlightNumber"
              :class="[{ 'have-value': !!departureFlightNumber }]"
              type="text"
              name="departureFlightNumber"
              data-val="true"
              data-field-type="SingleLineText"
            >

            <label
              for="departureFlightNumber"
              class="req floating"
            >
              {{ addOn.departureFlightNumberLabel }}
            </label>

            <span
              data-valmsg-for="departureFlightNumber"
              data-valmsg-replace="true"
              class="field-validation-valid"
            />
          </div>
        </div>
        <div class="flex-grid-2-col gutter-lg">
          <div class="input dropdown">
            <select
              id="departureDate"
              v-model="departureDate"
              :class="[{ 'have-value': !!departureDate }]"
              name="departureDate"
              data-val="true"
              data-field-type="DropdownList"
            >
              <option
                v-for="(date) in datesAvailable"
                :key="`date-${date.value}`"
                :value="date.value"
              >
                {{ date.label }}
              </option>
            </select>

            <label
              for="departureDate"
              class="req floating"
            >
              {{ addOn.departureDateLabel }}
            </label>

            <span
              data-valmsg-for="departureDate"
              data-valmsg-replace="true"
              class="field-validation-valid"
            />
          </div>
          <div class="input">
            <input
              id="estimatedDepartureTime"
              v-model="estimatedDepartureTime"
              :class="[{ 'have-value': !!estimatedDepartureTime }]"
              type="text"
              name="estimatedDepartureTime"
              data-val="true"
              data-field-type="SingleLineText"
            >

            <label
              for="estimatedDepartureTime"
              class="req floating"
            >
              {{ addOn.estimatedTimeOfDepartureLabel }}
            </label>

            <span
              data-valmsg-for="estimatedDepartureTime"
              data-valmsg-replace="true"
              class="field-validation-valid"
            />
          </div>
        </div>
        <div class="flex-grid-1-col gutter-lg">
          <div class="input">
            <textarea
              id="departureNotes"
              v-model="departureNotes"
              :class="[{ 'have-value': !!departureNotes }]"
              name="departureNotes"
              data-val="true"
              rows="3"
              data-field-type="MultipleLineText"
            />

            <label
              for="departureNotes"
              class="floating"
            >
              {{ addOn.departureNotesLabel }}
            </label>

            <span
              data-valmsg-for="departureNotes"
              data-valmsg-replace="true"
              class="field-validation-valid"
            />
          </div>
        </div>
      </fieldset>
    </form>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import moment from 'moment'
  import { formatDateZone } from '@utils/date-helpers'
  const REQUIRED_FIELDS = ['vehicleType', 'arrivalType', 'arrivalFlightNumber', 'arrivalAirport', 'arrivalDate', 'estimatedArrivalTime',
                           'departureType', 'departureAirport', 'departureFlightNumber', 'departureDate', 'estimatedDepartureTime']

  export default {
    name: 'AirportTransferService',
    props: {
      addOn: {
        type: Object,
        required: true
      },
      data: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        vehicleType: null,
        arrivalType: null,
        arrivalFlightNumber: null,
        arrivalAirport: null,
        arrivalDate: null,
        estimatedArrivalTime: null,
        arrivalNotes: null,

        departureType: null,
        departureAirport: null,
        departureFlightNumber: null,
        departureDate: null,
        estimatedDepartureTime: null,
        departureNotes: null,
      }
    },
    computed: {
      ...mapState('i18n', ['translations']),
      ...mapGetters('i18n', ['tc']),
      ...mapGetters('currency', ['getDisplayPrice']),
      ...mapGetters('booking', ['showPricesWithTaxes']),

      initializedData() {
        return {
          vehicleType: this.data?.vehicleType || this.addOn?.synXisId || this.vehicleOptions[0].key,

          arrivalType: this.data?.arrivalType || null,
          arrivalFlightNumber: this.data?.arrivalFlightNumber || this.arrivalFlightNumber,
          arrivalAirport: this.data?.arrivalAirport || this.arrivalAirport,
          arrivalDate: this.data?.arrivalDate || this.arrivalDate,
          estimatedArrivalTime: this.data?.estimatedArrivalTime || this.estimatedArrivalTime,
          arrivalNotes: this.data?.arrivalNotes || this.arrivalNotes,

          departureType: this.data?.departureType || null,
          departureAirport: this.data?.departureAirport || this.departureAirport,
          departureFlightNumber: this.data?.departureFlightNumber || this.departureFlightNumber,
          departureDate: this.data?.departureDate || this.departureDate,
          estimatedDepartureTime: this.data?.estimatedDepartureTime || this.estimatedDepartureTime,
          departureNotes: this.data?.departureNotes || this.departureNotes,
        }
      },
      todaysDate() {
        return moment().format('YYYY-MM-DD')
      },
      oneYearLaterDate() {
        return moment().add(1, 'year').format('YYYY-MM-DD')
      },
      vehicleOptions() {
        return this.addOn.vehicleTypeDetails.filter((vehicle, index) => this.addOn.vehicleDetails.some((detail) => detail.synxisId === vehicle.key))
      },
      datesAvailable() {
        const selectedVehicle = this.addOn.vehicleDetails.find((vehicle) => vehicle.synxisId === this.vehicleType)
        if (selectedVehicle) {
          return selectedVehicle.price.map((price) => ({
            label: formatDateZone(price.effectiveDate, null, 'DD/MM/YYYY'),
            value: price.effectiveDate.includes('T') ? price.effectiveDate : `${price.effectiveDate}T00:00:00Z`
          }))
        }
        return []
      },
      arrivalOptions() {
        return this.addOn.arrivalType
      },
      departureOptions() {
        return this.addOn.departureType
      },
      showArrivalSection() {
        const selectedVehicleDetails = this.getVehicleDetails(this.vehicleType)
        return !!selectedVehicleDetails?.availableOnArrival
      },
      showDepartureSection() {
        const selectedVehicleDetails = this.getVehicleDetails(this.vehicleType)
        return !!selectedVehicleDetails?.availableOnDeparture
      },
    },
    watch: {
      arrivalDate() {
        this.validateForm()
      },
      departureDate() {
        this.validateForm()
      },
      vehicleType(newVal, oldVal) {
        const newVehicleDetails = this.getVehicleDetails(newVal)
        const oldVehicleDetails = this.getVehicleDetails(oldVal)
        if (newVal && oldVal) {
          this.$emit('reset-quantity')
          if (newVehicleDetails?.availableOnArrival !== oldVehicleDetails?.availableOnArrival
            || newVehicleDetails?.availableOnDeparture !== oldVehicleDetails?.availableOnDeparture) {
            this.resetForm()
          }
        }
      }
    },
    mounted() {
      Object.assign(this.$data, this.initializedData)
      this.validateForm()
      this.$emit('input', this.$data)
    },
    methods: {
      resetForm() {
        this.arrivalType = null
        this.arrivalFlightNumber = null
        this.arrivalAirport = null
        this.arrivalDate = null
        this.estimatedArrivalTime = null
        this.arrivalNotes = null

        this.departureType = null
        this.departureAirport = null
        this.departureFlightNumber = null
        this.departureDate = null
        this.estimatedDepartureTime = null
        this.departureNotes = null

        this.validateForm()
      },
      validateForm() {
        const requiredFieldsVisible = REQUIRED_FIELDS.filter((field) => !((field.toLowerCase().includes('arrival') && !this.showArrivalSection) || (field.toLowerCase().includes('departure') && !this.showDepartureSection)))

        const hasRequiredAndEmpty = requiredFieldsVisible.some((field) => this.$data[field] === null || this.$data[field] === '')
        this.$emit('is-valid', !hasRequiredAndEmpty)
        this.$emit('input', this.$data)
      },
      getVehicleDetails(vehicleSynXisId) {
        return this.addOn.vehicleDetails.find((vehicle) => vehicle.synxisId === vehicleSynXisId)
      },
      getVehicleOptWithPrice(vehicleOpt) {
        const vehicleOptDetails = this.getVehicleDetails(vehicleOpt.key)
        const priceWithoutTax = vehicleOptDetails?.price[0]?.base?.amountBeforeTaxField
        const priceWithTax = vehicleOptDetails?.price[0]?.base?.amountAfterTaxField
        const formattedPrice = this.getDisplayPrice({ price: this.showPricesWithTaxes() ? priceWithTax : priceWithoutTax })
        return vehicleOpt.value?.replace('{{Price}}', formattedPrice)
      }
    }
  }
</script>
